import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useStepRouteSync = (
  currentStep: number,
  stepPaths: Record<number, string>,
  basePath: string,
) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const targetPath = stepPaths[currentStep] || basePath;
    if (location.pathname !== targetPath) {
      navigate(targetPath, { replace: true });
    }
  }, [currentStep, navigate, location.pathname, stepPaths, basePath]);
};

export default useStepRouteSync;
